import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <section
      className="relative py-8 md:py-12 border-y border-black/10 bg-neutral-50 overflow-hidden"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        {row.map((word, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-semibold text-4xl md:text-6xl px-8 text-stroke uppercase tracking-tight whitespace-nowrap">
              {word}
            </span>
            <span className="text-[#1478FF] text-2xl md:text-4xl px-2">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
